import gql from "graphql-tag";
import { getAthenaAppsyncClient } from "../appsync";


const getCourseToc = gql` query getCourseToc($id:ID!){
  getCourse(id: $id) {
    id
    title
    chapters {
      items {
        id
        title
        sequence
        is_locked
        subchapters {
          items {
            id
            title
            sequence
            videos
          }
        }
      }
    }
  }
}`
const getQuestionJson = gql`query getQuestionJson($questionLug:String!){
  getQuestionJSON(questionLug:$questionLug)
}`
const getQuestion = gql`query getQuestion($questionLug:ID!){
  getQuestion(id:$questionLug){
    content_type
    content{
      h5p_json
    }
    meta{
      difficulty_level
      blooms
      concept_name
    }
  }
}`

export default {
  GetCourseToc: async (courseGuid) => {
    // e339d133-d1d2-4fe2-ac9c-f5fedfe4354b
    const athenaClint = await getAthenaAppsyncClient()
    if (!athenaClint)
      throw new Error("Athena app client not initialized");
    try {
      const variables = {id:courseGuid}
      const data = await athenaClint
        .query({
          variables,
          query: getCourseToc,
          fetchPolicy: "network-only",
        })
      
      let course = data.data.getCourse
      let toReturn = {...course,"chapters":course.chapters.items.map(c=>{return {...c,"subchapters":c.subchapters.items}})}
      return toReturn
    } catch (error) {
      console.log(error);
      throw error
    }
  },

  GetQuestionJson: async (questionLug)=>{
    const athenaClint = await getAthenaAppsyncClient()
    if (!athenaClint)
      throw new Error("Athena app client not initialized");
    try {
      const variables = {questionLug}
      const data = await athenaClint
        .query({
          variables,
          query: getQuestion,
          fetchPolicy: "network-only",
        })
      
     return data.data.getQuestion
    } catch (error) {
      console.log(error);
      throw error
    }
  }
}
